import { render } from "./imageSwiper.vue?vue&type=template&id=0b070a35&scoped=true"
import script from "./imageSwiper.vue?vue&type=script&lang=js"
export * from "./imageSwiper.vue?vue&type=script&lang=js"

import "./imageSwiper.vue?vue&type=style&index=0&id=0b070a35&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b070a35"]])

export default __exports__